import PropTypes from 'prop-types'

const ButtonSocial = ({ name, url }) => (
  <a href={url} title={name} target="_blank" rel="noopener noreferrer">
    <i className={`glyph glyph-${name} share-button share-button-${name}`} />
  </a>
)

ButtonSocial.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
}

export default ButtonSocial
